import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {createChat, deleteChat, fetchChatById, fetchChats, updateChat,} from './chat-history-api';

/* ---------------------- LIST (چت‌ها) ---------------------- */
export const useChats = (page = 0, pageSize = 10, filters = {}) =>
    useQuery({
        queryKey: ['chats', page, pageSize, filters],
        queryFn: () => fetchChats(page, pageSize, filters),
        keepPreviousData: true,
    });

/* ---------------------- SINGLE (یک چت) ---------------------- */
export const useChat = (id) =>
    useQuery({
        queryKey: ['chat', id],
        queryFn: () => fetchChatById(id),
        enabled: !!id,
    });

/* ---------------------- CREATE ---------------------- */
export const useCreateChat = (onSuccess) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: createChat,
        onSuccess: (data) => {
            queryClient.invalidateQueries({queryKey: ['chats']});
            onSuccess?.(data);
        },
    });
};

/* ---------------------- UPDATE ---------------------- */
export const useUpdateChat = (onSuccess) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateChat,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({queryKey: ['chats']});
            if (variables?.id) {
                queryClient.setQueryData(['chat', variables.id], data);
            }
            onSuccess?.(data);
        },
    });
};

/* ---------------------- DELETE ---------------------- */
export const useDeleteChat = (onSuccess) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteChat,
        onSuccess: (_, id) => {
            queryClient.invalidateQueries({queryKey: ['chats']});
            queryClient.removeQueries({queryKey: ['chat', id]});
            onSuccess?.();
        },
    });
};